export const userHash = async (uuid: string | undefined): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(uuid || '');
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};
